import { Cssify } from './utils/cssify';
import { stableHash } from './stableHash';
export function getCSSIdAndRuleset(styleValueResolvedWithMeta, objectHash, prefixClassName = ''
// path: Path
) {
  var _styleValueResolvedWi, _styleValueResolvedWi2;
  const hasState = (_styleValueResolvedWi = styleValueResolvedWithMeta.meta.path) === null || _styleValueResolvedWi === void 0 ? void 0 : _styleValueResolvedWi.includes('state');
  const toBeInjectedStyle = {
    style: styleValueResolvedWithMeta.resolved
  };
  if (styleValueResolvedWithMeta.meta.queryCondition && styleValueResolvedWithMeta.meta.colorMode) {
    toBeInjectedStyle.condition = styleValueResolvedWithMeta.meta.queryCondition;
    toBeInjectedStyle.colorMode = styleValueResolvedWithMeta.meta.colorMode;
  } else if (styleValueResolvedWithMeta.meta.queryCondition) {
    toBeInjectedStyle.condition = styleValueResolvedWithMeta.meta.queryCondition;
  } else if (styleValueResolvedWithMeta.meta.colorMode) {
    toBeInjectedStyle.colorMode = styleValueResolvedWithMeta.meta.colorMode;
  }
  // @ts-ignore
  if (styleValueResolvedWithMeta.meta.theme) {
    // @ts-ignore
    toBeInjectedStyle.theme =
    // @ts-ignore
    styleValueResolvedWithMeta.meta.theme;
  }

  //@ts-ignore
  const cssObject = Cssify.create({
    style: toBeInjectedStyle
  },
  // 'helloworld'
  objectHash + '-' + stableHash({
    path: styleValueResolvedWithMeta === null || styleValueResolvedWithMeta === void 0 || (_styleValueResolvedWi2 = styleValueResolvedWithMeta.meta) === null || _styleValueResolvedWi2 === void 0 ? void 0 : _styleValueResolvedWi2.path,
    data: styleValueResolvedWithMeta.original
  }), prefixClassName, hasState);
  return cssObject;
}
export function INTERNAL_updateCSSStyleInOrderedResolved(orderedSXResolved, objectHash, keepOriginal = false, prefixClassName = '', shouldResolve = true) {
  orderedSXResolved.forEach(styleResolved => {
    if (shouldResolve) {
      const cssData = getCSSIdAndRuleset(styleResolved, objectHash, prefixClassName);
      if (!keepOriginal) {
        delete styleResolved.resolved;
        delete styleResolved.original;
      }
      // console.log(styleResolved, 'CSS DATA');

      styleResolved.meta.cssId = cssData.ids.style;
      styleResolved.meta.cssRuleset = cssData.rules.style;
    } else {
      var _styleResolved$meta;
      styleResolved.meta.cssId = objectHash + '-' + stableHash({
        path: styleResolved === null || styleResolved === void 0 || (_styleResolved$meta = styleResolved.meta) === null || _styleResolved$meta === void 0 ? void 0 : _styleResolved$meta.path,
        data: styleResolved.original
      });
    }
  });
}
//# sourceMappingURL=updateCSSStyleInOrderedResolved.web.js.map